/**
 * LikesStep.validation.js
 *
 * Pure function, no React — mirrors FoodPreferencesStep.validation.js.
 * Likes is entirely optional per the FSD, so isValid is only ever false
 * in the defensive case where something manages to push more than
 * MAX_LIKES entries into formData.likes (the UI itself prevents this by
 * disabling further selection once the cap is hit — see LikesStep.js).
 */

import { MAX_LIKES } from "./LikesStep.constants";

export function validateLikes(data) {
  const errors = {};

  if (!Array.isArray(data.likes)) {
    errors.likes = "Likes must be a list.";
  } else if (data.likes.length > MAX_LIKES) {
    errors.likes = `Please select at most ${MAX_LIKES} foods.`;
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
